import DashboardFilterRef from '@/util/DashboardFilterRef';
import { DATE, DATETIME } from '@/util/ColumnType';

export const getColumnType = (filter: DashboardFilterRef) =>
  filter.columnType().type() === DATE
    ? [DATE, DATETIME]
    : [filter.columnType().type()];
